import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  ErrorMessage,
  Field,
  Form,
  Formik,
} from 'formik'
import {
  FormControl,
  FormControlLabel,
  Grid,
  Typography,
  TextField,
  Link as MuiLink,
} from '@material-ui/core'

import Link from '../controls/Link'
import SpinnerSubmitButton from '../controls/buttons/SpinnerSubmitButton'
import InputValidationTooltip from '../controls/input/InputValidationTooltip'

import SmallArrowRight from '../../../assets/images/icons/ico_arrow_small.svg'

class PasswordView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    email: PropTypes.string.isRequired,
  }

  static styles = (theme) => ({
    formControl: {
      width: '100%',
      margin: theme.spacing(4, 0, 0, 0),
    },
    labelRoot: theme.formControlLabelRoot,
    label: theme.label,
    textFieldRoot: theme.loginTextFieldRoot,
    actionItem: {
      marginTop: theme.spacing(4),
    },
    link: theme.loginLink,
  })

  validateForm = (values) => {
    const errors = {}

    if (!values.password.trim()) {
      errors.password = 'Password required'
    }

    return errors
  }

  handleNext = (values) => {
    this.props.onSubmit(values.password)
  }

  render() {
    const { classes, email } = this.props

    return (
      <Formik
        initialValues={{
          password: '',
        }}
        validate={this.validateForm}
        onSubmit={this.handleNext}
      >
        {(formikProps) => (
          <Form>
            <Typography variant="h1">Welcome to BlokSense</Typography>
            <Typography variant="h2">Sign in to your Insights Dashboard</Typography>

            <Field
              name="password"
              value={formikProps.values.password}
              onChange={formikProps.handleChange}
              onBlur={formikProps.handleBlur}
            >
              {({ field, form: { touched, errors } }) => (
                <FormControl className={classes.formControl}>
                  <FormControlLabel
                    classes={{ root: classes.labelRoot, label: classes.label }}
                    label="Password"
                    labelPlacement="top"
                    control={(
                      <TextField
                        {...field}
                        type="password"
                        classes={{ root: classes.textFieldRoot }}
                        error={touched.password && Boolean(errors.password)}
                        fullWidth
                        placeholder="Password"
                        variant="outlined"
                      />
                    )}
                  />
                  <ErrorMessage name="password">
                    { (msg) => <InputValidationTooltip title={msg} /> }
                  </ErrorMessage>
                </FormControl>
              )}
            </Field>

            <Grid container justify="space-between" alignItems="center">
              <Grid item className={classes.actionItem}>
                <SpinnerSubmitButton
                  onClick={formikProps.handleSubmit}
                  isSubmitting={formikProps.isSubmitting}
                >
                  Sign in
                  <img src={SmallArrowRight} alt="→" />
                </SpinnerSubmitButton>
              </Grid>
              <Grid item className={classes.actionItem}>
                <MuiLink component={Link} to={{ pathname: '/login/forgot', state: { email } }} className={classes.link}>
                  Forgot password?
                </MuiLink>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    )
  }
}

export default withStyles(PasswordView.styles)(PasswordView)
